import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";
import { IAccountSearchParams } from "../../store/slices/agreementsSearch/types/IAccountSearchParams";
import { IAgreementSearchParams } from "../../store/slices/agreementsSearch/types/IAgreementSearchParams";

export const fetchAccountsRoute = (params: IAccountSearchParams) => {
  return buildUrl({
    url: [baseUrl, "accounts-api", "accounts", "pageable-search"].join("/"),
    searchParams: {
      ...params,
    },
  });
};

export const fetchAgreementsRoute = (params: IAgreementSearchParams) => {
  const page = params.page ? params.page : 0;
  const size = params.size ? params.size : 20;
  return buildUrl({
    url: [baseUrl, "accounts-api", "agreements", "pageable-search"].join("/"),
    searchParams: {
      ...params,
      page,
      size,
    },
  });
};
